/*
 * @Author: Ryan
 * @Date: 2025-12-29
 * @Description: SEO sections entry file for ai-voice-cloning page
 */
import React from 'react';

import { CHARACTER_VIDEOS } from '../_components/VoiceSelector/characterData';
import ComparisonSection from './ComparisonSection';
import CTASection from './CTASection';
import ExploreToolsSection from './ExploreToolsSection';
import FAQSection from './FAQSection';
import HeroSection from './HeroSection';
import HowToUseSection from './HowToUseSection';
import PowerfulFeaturesSection from './PowerfulFeaturesSection';
import TestimonialsSection from './TestimonialsSection';
import UseCasesSection from './UseCasesSection';
import WhyChooseSection from './WhyChooseSection';

const SEOSections: React.FC = () => {
  return (
    <>
      {/* 隐藏的 SEO 内容 - 供爬虫抓取，使用原生标签 + lazy/preload=none 避免实际加载 */}
      <div className="sr-only" aria-hidden="true">
        <h2>AI Voice Cloning Samples</h2>
        {CHARACTER_VIDEOS.map((character) => (
          <article key={character.id}>
            <h3>{character.name}</h3>
            <p>{character.script}</p>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src={character.thumbnailUrl}
              alt={character.name}
              width={100}
              height={100}
              loading="lazy"
            />
            <video poster={character.posterUrl} preload="none">
              <source src={character.videoUrl} type="video/mp4" />
            </video>
          </article>
        ))}
      </div>
      {/* 暂时隐藏 Sample Voices 板块，待音色资源准备好后再开启 */}
      {/* <HeroSection /> */}
      <HowToUseSection />
      <PowerfulFeaturesSection />
      <UseCasesSection />
      <WhyChooseSection />
      <ComparisonSection />
      <TestimonialsSection />
      <ExploreToolsSection />
      <FAQSection />
      <CTASection />
    </>
  );
};

export default SEOSections;

// 也导出单独的组件,方便按需引入
export {
  ComparisonSection,
  CTASection,
  ExploreToolsSection,
  FAQSection,
  HeroSection,
  HowToUseSection,
  PowerfulFeaturesSection,
  TestimonialsSection,
  UseCasesSection,
  WhyChooseSection,
};
export { default as StartButton } from './StartButton';
